import { render, staticRenderFns } from "./ApmsRegFarmingInfoDetail.vue?vue&type=template&id=01ca9172&scoped=true&"
import script from "./ApmsRegFarmingInfoDetail.vue?vue&type=script&lang=js&"
export * from "./ApmsRegFarmingInfoDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ca9172",
  null
  
)

export default component.exports